export default "__VITE_ASSET__D6ovN6Td__"